<div class="modal-content">
    <div class="modal-header mb-n1">
        <app-close-button (callbackFunction)="modalRef.hide()"></app-close-button>
    </div>
    <div class="modal-body p-0" role="alert">
        <div class="row pl-3 pr-3">
            <div class="col-12 text-center">
                <p>{{ 'MODAL.SECOND_PRODUCT' | translate }}</p>
            </div>
        </div>
        <div class="row desktop">
            <div class="col-6 w-100 float-left pt-3 text-center pb-3 pr-4 pl-4 mt-2"
                style="">
                <!-- <a class="btn primary-btn waves-light float-left" mdbBtn mdbWavesEffect (click)="view='2'"><mdb-icon fas icon="arrow-left"></mdb-icon> Go Back</a> -->
                <a (click)="modalRef.hide()" id="paymentTermsChangeContinueButtonDesktop" tabindex="0" (click)="addNewItem()"
                    class="btn primary-btn waves-light float-right" mdbBtn mdbWavesEffect>{{ 'MODAL.CONTINUE' | translate }}</a>
            </div>
            <div class="col-6 w-100 float-left pt-3 text-center pb-3 pr-4 pl-4 mt-4">
                <!-- <a class="btn primary-btn waves-light float-left" mdbBtn mdbWavesEffect (click)="view='2'"><mdb-icon fas icon="arrow-left"></mdb-icon> Go Back</a> -->
                <a id="paymentTermsChangeBackLinkDesktop" (click)="modalRef.hide()" tabindex="0" class="click-text">{{ 'MODAL.BACK' | translate }}</a>
            </div>
        </div>
        <div class="row mobile">
            <div class="col-12 w-100 text-center"
                style="">
                <!-- <a class="btn primary-btn waves-light float-left" mdbBtn mdbWavesEffect (click)="view='2'"><mdb-icon fas icon="arrow-left"></mdb-icon> Go Back</a> -->
                <a (click)="modalRef.hide()" id="paymentTermsChangeContinueButtonMobile" tabindex="0" (click)="addNewItem()"
                    class="btn primary-btn waves-light" mdbBtn mdbWavesEffect>{{ 'MODAL.CONTINUE' | translate }}</a>
            </div>
        </div>
        <div class="row mobile">
            <div class="col-12 w-100 pt-2 text-center">
                <!-- <a class="btn primary-btn waves-light float-left" mdbBtn mdbWavesEffect (click)="view='2'"><mdb-icon fas icon="arrow-left"></mdb-icon> Go Back</a> -->
                <a id="paymentTermsChangeBackLinkMobile" (click)="modalRef.hide()" tabindex="0" class="click-text">{{ 'MODAL.BACK' | translate }}</a>
            </div>
        </div>
    </div>
</div>
